// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2c-2w","containerItemsCenter":"Skeleton_containerItemsCenter__3dxy9"};